import { helpers, minValue } from '@vuelidate/validators'

export const minValueValidator = (...params: Parameters<typeof minValue>) =>
  helpers.withMessage(
    ({ $params }) => `El valor mínimo permitido es ${$params.min}`,
    helpers.withParams({}, minValue(...params))
  )
